import { StateCreator } from 'zustand';
import { GameStore } from '@/features/games/shared/store/game-store';
import { WishlistsSlice } from '@/features/games/shared/types/wishlist.types';
import {
  bustWishlistsCache,
  fetchWishlistsCached,
} from '@/features/games/internal/helpers/browser-clients/fetch-wishlists';

export const createWishlistsSlice: StateCreator<GameStore, [], [], WishlistsSlice> = (set) => ({
  wishlistData: null,
  wishlistLoaded: false,
  bustWishlistCache: () => {
    bustWishlistsCache();
  },
  fetchWishlists: async () => {
    try {
      const wishlistData = await fetchWishlistsCached();
      set({
        wishlistData,
        wishlistLoaded: true,
      });
    } catch (err) {
      console.error('Failed to fetch purchase history:', err);
    }
  },
});
